const { gql } = require("graphql.macro");
const queryDropdownDefaultOption = gql`query dropdownQuery($itemPath: String = "/sitecore/content/lynkco-global-portal/Global Setting/Dropdown-mobile-default", $language: String = "en") {
  # Datasource query
  # $datasource will always be set to the ID of the rendering's datasource item
  # (as long as the GraphQLData helper is used)
  dropdown: item(path: $itemPath, language: $language)
  {
    name
       fields (ownFields: true) {
       name
       value
    }
  }
}`;
export default queryDropdownDefaultOption;
